import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  Box, Typography, Grid, Paper, Avatar, Stack
} from '@mui/material';
import ButtonBase from '@mui/material/ButtonBase';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import { apigetPublic } from '../../service/api';
import Footer from '../../components/Footer/footer';


function normalizeGroups(groups) {
  const result = [];

  function unwrap(value) {
    if (Array.isArray(value)) {
      value.forEach(unwrap);
      return;
    }

    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        unwrap(parsed); // 🔥 recurse again
      } catch {
        result.push(value);
      }
    }
  }

  unwrap(groups);

  return result
    .map(g => g.toLowerCase().trim())
    .filter(Boolean);
}

function toTitleCase(str = '') {
  return str
    .replace(/-/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
}


export default function GroupPage() {
  const { groupSlug } = useParams();

  const [officers, setOfficers] = useState([]);

  useEffect(() => {
    const loadGroupPage = async () => {
      const loRes = await apigetPublic('loanofficer/search');
      if (loRes?.status !== 200) return;

      const allOfficers = loRes.data.result || [];

      const filtered = allOfficers.filter((officer) => {
  const groups = normalizeGroups(officer.groups);
  return groups.includes(groupSlug.toLowerCase());
});


      setOfficers(filtered);
    };

    loadGroupPage();
  }, [groupSlug]);

return (
  <>
    <LandingPageNav />

    {/* PAGE WRAPPER */}
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* MAIN CONTENT */}
      <Box
        sx={{
          flex: 1,
          px: 4,
          pt: 12,
          pb: 6,
          maxWidth: 1200,
          mx: 'auto',
          width: '100%',
        }}
      >
        {/* HERO */}
        <Box sx={{ mb: 6 }}>
          <Typography variant="h3" fontWeight="bold" gutterBottom>
  {toTitleCase(groupSlug)}
</Typography>


          <Typography variant="body1">
           Our experienced team is here to help you explore your options and find the perfect loan solution for your needs. 
          </Typography>
        </Box>

        {/* LO LIST */}
        <Grid container spacing={4}>
          {officers.map((officer) => (
            <Grid item xs={12} md={4} key={officer._id}>
              <ButtonBase
                component={Link}
                to={`/${officer.slug}`}
                sx={{ width: '100%', textAlign: 'left' }}
              >
                <Paper sx={{ p: 3 }}>
                  <Stack alignItems="center" spacing={2}>
                    <Avatar
                      sx={{ width: 80, height: 80 }}
                      src={officer.imageUrl}
                    />
                    <Typography variant="h6">
                      {officer.firstName} {officer.lastName}
                    </Typography>
                    <Typography variant="body2">
                      {officer.title}
                    </Typography>
                    <Typography variant="body2">
                      {officer.phone}
                    </Typography>
                    <Typography variant="body2">
                      {officer.email}
                    </Typography>
                  </Stack>
                </Paper>
              </ButtonBase>
            </Grid>
          ))}
        </Grid>

        {officers.length === 0 && (
          <Typography sx={{ mt: 4 }}>
            No loan officers found for this group.
          </Typography>
        )}
      </Box>

      {/* FOOTER */}
      <Footer />
    </Box>
  </>
);

}
